import { __decorate } from "tslib";
import { proxy, subscribe } from '@/infrastructure/object-reactive/object-reactive';
import { injectable } from '@/inversify.config';
import { DEFAULT_FOLDER_SETTING } from '../constants';
import _ from 'lodash';
let FolderSettingModelImpl = class FolderSettingModelImpl {
    constructor() {
        this._folderSetting = proxy(_.cloneDeep(DEFAULT_FOLDER_SETTING));
    }
    get folderSetting() {
        return this._folderSetting.value;
    }
    updateFolderSetting(folderSetting) {
        this._folderSetting.value = {
            ...this.folderSetting,
            ...folderSetting,
        };
    }
    updateCollapseSetting(collapseSetting) {
        this._folderSetting.value = {
            ...this.folderSetting,
            collapse_setting: collapseSetting,
        };
    }
    updateVisibleFields(visibleFields) {
        this._folderSetting.value = {
            ...this.folderSetting,
            visible_fields: visibleFields,
        };
    }
    updateFreezeFields(freezeFields) {
        this._folderSetting.value = {
            ...this.folderSetting,
            freeze_fields: freezeFields,
        };
    }
    updateFilterFields(filterFields) {
        this._folderSetting.value = {
            ...this.folderSetting,
            filter_fields: filterFields,
        };
    }
    updateCurrentSort(currentSort) {
        this._folderSetting.value = {
            ...this.folderSetting,
            current_sort: currentSort,
        };
    }
    clearFolderSetting() {
        this._folderSetting.value = _.cloneDeep(DEFAULT_FOLDER_SETTING);
    }
    subscribe(callback) {
        const dispose = subscribe(() => this._folderSetting.value, (newVal) => {
            callback(newVal);
        });
        return dispose;
    }
};
FolderSettingModelImpl = __decorate([
    injectable()
], FolderSettingModelImpl);
export { FolderSettingModelImpl };
